import { Component, Input, OnInit } from '@angular/core';
import { CommonColor, KbnStatus, TrainingType } from '@core/constants';

export interface TrainingData {
  type: number;
  date: string;
  attention_flg?: boolean;
}

@Component({
  selector: 'caremoni-training',
  templateUrl: './training.component.html',
  styleUrl: './training.component.scss'
})
export class TrainingComponent implements OnInit {
  @Input() data: TrainingData = { type: KbnStatus.STATUS_EMPTY, date: '' };
  @Input() config: any;

  trainingText: string = "";
  trainingType: number = KbnStatus.STATUS_EMPTY;
  textColor: string = "white";
  borderStyle: string = "";
  borderRadius: string = "";
  isCancelTraining: boolean = false;
  attention_flg: boolean = false;
  labelConfig: any = {};

  ngOnInit(): void {
    this.setTrainingInfo(this.data);
    this.labelConfig = {
      textColor: this.textColor,
      minWidth: '3vw',
      minHeight: '5.8vh',
      labelPosition: 'center',
      highlight: this.attention_flg ? true : false,
      borderStyle: this.borderStyle,
      borderRadius: this.borderRadius,
      borderWidth: '1px',
      borderColor: ''
    };
  }

  setTrainingInfo(training: TrainingData) {
    this.trainingType = training?.type ?? TrainingType.NONE;
    this.isCancelTraining = false;
    this.attention_flg = training?.attention_flg || false;

    if (this.attention_flg || this.trainingType == TrainingType.CANCEL) {
      this.textColor = CommonColor.ATTENTION_COLOR;
    }

    if (this.trainingType == TrainingType.IMPLEMENT) {
      this.borderStyle = 'solid';
      this.borderRadius = '6px';
    }

    switch (this.trainingType) {
      case TrainingType.IMPLEMENT:
        this.trainingText = "実施";
        break;
      case TrainingType.CANCEL:
        this.isCancelTraining = !!this.config?.activeCancelMark;
        this.trainingText = "中止";
        break;
      default:
        this.trainingText = "";
        break;
    }
  }
}
